export const iconFontAwesomeHolidaysCandyCane = (
	<i className="fa-solid fa-candy-cane"></i>
);
